import { create } from 'zustand'

const useTopNavHeight = create<{
  height: number
  setHeight: (height: number) => void
  getStickyOffset: () => number
}>((set, get) => ({
  getStickyOffset: () => get().height + 24,
  height: 72,
  setHeight: height => set({ height }),
}))

export default useTopNavHeight
